import { useState, useEffect, useCallback } from 'react';

type DropdownType = 'userMenu' | 'notifications' | 'tradingOptions' | 'marketDropdown' | 'sidebar' | 'wallet' | 'withdrawals' | null;

export const useDropdown = () => {
  const [activeDropdown, setActiveDropdown] = useState<DropdownType>(null);

  const openDropdown = useCallback((dropdownType: DropdownType) => {
    setActiveDropdown(dropdownType);
  }, []);

  const closeDropdown = useCallback(() => {
    setActiveDropdown(null);
  }, []);

  const toggleDropdown = useCallback((dropdownType: DropdownType) => {
    if (activeDropdown === dropdownType) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownType);
    }
  }, [activeDropdown]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      
      // Check if click is outside any dropdown
      if (!target.closest('[data-dropdown]')) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close dropdown when pressing Escape key
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return {
    activeDropdown,
    openDropdown,
    closeDropdown,
    toggleDropdown,
    isOpen: (dropdownType: DropdownType) => activeDropdown === dropdownType,
  };
};
